/* unplugin-vue-components disabled */import { render } from "./NoMore.vue?vue&type=template&id=30616a68&scoped=true"
import script from "./NoMore.vue?vue&type=script&lang=js"
export * from "./NoMore.vue?vue&type=script&lang=js"

import "./NoMore.vue?vue&type=style&index=0&id=30616a68&scoped=true&lang=less"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30616a68"]])

export default __exports__